import { useMemo } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const CARD_VIEWPORT = { once: true, margin: "-60px" };
const CARD_INITIAL = { opacity: 0, y: 24 };
const CARD_WHILE_IN_VIEW = { opacity: 1, y: 0 };

export const GearCard = ({ item, index, onQuote }) => {
  const transition = useMemo(() => ({ duration: 0.5, delay: (index % 3) * 0.1 }), [index]);
  return (
    <motion.div
      data-testid={`gear-card-${item.name.toLowerCase().replace(/\s+/g, "-")}`}
      initial={CARD_INITIAL}
      whileInView={CARD_WHILE_IN_VIEW}
      viewport={CARD_VIEWPORT}
      transition={transition}
      className="group bg-card border border-border/60 rounded-2xl overflow-hidden flex flex-col"
    >
      <div className={`relative h-56 overflow-hidden ${item.fit === "contain" ? "bg-secondary/30 flex items-center justify-center p-4" : ""}`}>
        <img
          src={item.image}
          alt={item.name}
          loading="lazy"
          decoding="async"
          className={
            item.fit === "contain"
              ? "max-w-full max-h-full object-contain transition-transform duration-700 group-hover:scale-105"
              : "w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          }
        />
        {item.fit !== "contain" && (
          <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-heading text-2xl font-bold text-primary mb-2">{item.name}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed flex-1">{item.desc}</p>
        <div className="flex flex-wrap gap-2 mt-4">
          {item.tags.map((t) => (
            <span key={t} className="text-[11px] uppercase tracking-wider px-3 py-1 rounded-full bg-secondary text-secondary-foreground font-medium">
              {t}
            </span>
          ))}
        </div>
        <button
          data-testid={`gear-quote-${item.name.toLowerCase().replace(/\s+/g, "-")}`}
          onClick={() => onQuote(item.name)}
          className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-accent group/btn"
        >
          Request this gear
          <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
        </button>
      </div>
    </motion.div>
  );
};
